const middleware = {}

middleware['seo'] = require('../src/middleware/seo.ts')
middleware['seo'] = middleware['seo'].default || middleware['seo']

export default middleware
